import { Modal } from '@mantine/core';
import { useMounted } from '@mantine/hooks';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'shared/lib';
import { gameHelpModalModel } from '../../model';
import { GameHelpModalContent } from '../game-help-modal-content';
import { GameHelpModalNavigation } from '../game-help-modal-navigation';
import cls from './game-help-modal.module.scss';

type GameHelpModalProps = {
	targetId: string;
};

export const GameHelpModal = ({ targetId }: GameHelpModalProps) => {
	const { t } = useTranslation();
	const { active, disable } = useUnit(gameHelpModalModel.switcher);
	const mounted = useMounted();
	const sm = useBreakpoint('sm', false);

	return (
		mounted && (
			<Modal
				id='game-help-modal'
				size={sm ? 'md' : 'sm'}
				opened={active}
				portalProps={{
					target: document.getElementById(targetId)!,
				}}
				title={t('game-help-modal.title')}
				classNames={{
					root: cls.gameHelpModal,
					overlay: cls.gameHelpModalOverlay,
					inner: cls.gameHelpModalInner,
					content: cls.gameHelpModalContent,
					body: cls.gameHelpModalBody,
				}}
				onClose={disable}
			>
				<GameHelpModalNavigation />
				<GameHelpModalContent />
			</Modal>
		)
	);
};
